/**
 * 全レコードの ID はクライアント生成 UUID（SPEC §2.2）。
 * POST は UPSERT なので、同じ ID で再送しても重複しない。
 */
export function uuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();

  // crypto.randomUUID はセキュアコンテキスト限定。
  // LAN の http:// で実機確認するときのためのフォールバック（RFC 4122 v4）。
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
